import type {AxiosError} from 'axios';

// This function picks only the required properties from the axios error object
// to avoid sending too much data to datadog
export const getMinimalAxiosErrorConfig = (error: AxiosError) => {
  return {
    url: error.config?.url,
    method: error.config?.method,
    baseUrl: error.config?.baseURL,
    params: error.config?.params,
  };
};
